import { render, staticRenderFns } from "./scene-view.vue?vue&type=template&id=3d08f403&scoped=true&"
import script from "./scene-view.vue?vue&type=script&lang=js&"
export * from "./scene-view.vue?vue&type=script&lang=js&"
import style0 from "./scene-view.vue?vue&type=style&index=0&id=3d08f403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08f403",
  null
  
)

export default component.exports